import {IPlatformApiProvider} from '@shared/services/platform-api-provider';

export class WorkspacePlatformApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/workspace')) {
      return 'AdminPanelApi';
    }
    return '';
  }
}
